import { api } from 'services/companiesApi';

export const getSummaryJobProfile = async (id: string) => {
	return await api.get(`/job-profiles/${id}/summary`);
};

export const deleteJobProfile = async (id: string) => {
	return await api.delete(`/job-profiles/${id}`);
};

export const downloadFile = async (id: string) => {
	return await api.get(`/job-risks/factors/${id}`);
};
